import React, { useState, Component } from 'react'
try {
    var ExtraMetadata = require('./ExtraMetadata').ExtraMetadata
    var ServiceLocator = require('live/services/service-locator').default

    ServiceLocator.getService('wellparameter-description').then(service => {
        service.WellParametersDescriptionRegistry.register({ component: ExtraMetadata, id: 'metadata' })
    })
} catch (e) {
    console.error('bp', e)
}